import React, { useMemo } from 'react';
import { useAtom } from 'jotai/index';
import styles from './css/index.module.scss';
import SimpleHeader from '../../../../ui-kit/SimpleHeader';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import EmptyHeight from '../../../EmptyHeight';
import Button from '../../../../ui-kit/Button';
import PersonalDataProcessingContent from '../../../PersonalDataProcessingContent';
import { siteModulesAtom } from '../../../../atoms/globalAtoms';

function PersonalDataProcessingModal({ onConfirm }) {
  const { t } = useTranslations();
  const [siteModules] = useAtom(siteModulesAtom);

  const privacyModule = useMemo(() => siteModules?.find((i) => i.module_name === 'privacy'), [siteModules]);

  return (
    <div className={styles.personalDataProcessingModal}>
      {privacyModule?.name ? (
        <p className={styles.title}>{privacyModule.name}</p>
      ) : (
        <>
          <p className={styles.title}>{t(DICTIONARY.personalDataAgreement.title1)}</p>
          <p className={styles.title}>{t(DICTIONARY.personalDataAgreement.title2)}</p>
        </>
      )}

      <EmptyHeight height={20} />
      <div className={styles.scrollableContent}>
        <PersonalDataProcessingContent />
      </div>
      <EmptyHeight height={25} />
      <Button
        // width={236}
        text={t(DICTIONARY.privacyPolicyCheckbox)}
        onClick={onConfirm}
      />
    </div>
  );
}

export default PersonalDataProcessingModal;
